import { getRequest } from '../utils'

export const getComments: RequestTypeVariable = {
  getKey: (projectGuid: string) => ['getComments', projectGuid],
  request: async (projectGuid: string): Promise<Comment3D[]> => {
    const { data } = await getRequest<Comment3D[]>({
      url: `/projects/${projectGuid}/comments`,
    })

    return data || []
  },
}
